/**
 * Authors: mariushirjanu, Triadi
 * Created: 29/07/2020
 * Upgraded: 28/10/2022
 */
import { Component, OnInit } from '@angular/core';
import { DialogSize, GaMessageService, IDialog } from '../../../shared/message/ga-message.service';
import { IUserData } from '../../../shared/services/auth/auth-data.service';
import { GaWizard } from '../../../shared/wizard/ga-wizard';
import { GaWizardService } from '../../../shared/wizard/ga-wizard.service';
import { WIZARD_DEMO } from '../../../shared/app-wizards';
import { UserProfileWrapperComponent } from '../../userprofile/user-profile-wrapper.component';

@Component({
  selector: 'wizard-demo-app',
  template: `
    <h2 id="title">This is demo app</h2>
    <a href="javascript: void(0)" id="wizard-dialog-trigger" (click)="openAnotherWizard()">Click here to open another wizard</a>
  `
})
export class WizardDemoAppComponent implements OnInit {
  private wizard:GaWizard;

  constructor(
    private messageService:GaMessageService,
    private wizardService:GaWizardService
  ) {
    this.wizard = this.wizardService.getInstance(WIZARD_DEMO);
  }

  public ngOnInit():void {
    // add actions
    this.wizard.actions([
      this.wizardService.createActionButton(
        'SAVE',
        'Save Demo',
        'btn btn-success',
        () => false
      )
    ]);
  }

  public openAnotherWizard():void {
    const dialog:IDialog = this.messageService.showDialog({
      title: 'User profile',
      component: UserProfileWrapperComponent,
      wrapperComponent: false,
      inputs: {
        userId: 7415,
        companyId: 34,
        showCancelButton: false
      },
      outputs: {
        onSaved: (userData:IUserData) => {
          console.log('onSave model', userData);
          dialog.hide();
        },
        onCancel: () => {
          console.log('onCancel');
          dialog.hide();
        }
      },
      size: DialogSize.XL,
      closeButton: true
    });
  }
}